<template lang="pug">
  .title-wrap(:style="wrapStyle")
    .header
      h1.title(:style="{ fontSize }")
        slot

      .actions(v-if='$slots.actions')
        slot(name='actions')

    .subtitle(v-if='$slots.subtitle')
      slot(name='subtitle')

</template>

<script>
export default {
  props: {
    fontSize: {
      type: String,
      default: "36px"
    },
    wrapStyle: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped lang="scss">
.title-wrap {
  margin-bottom: 40px;
}

.title {
  font-family: "gilroylight";
  font-weight: 400;
}

.subtitle {
  margin-top: 15px;
}

.header {
  display: flex;
  align-items: center;
}

.actions {
  margin-left: 20px;
}
</style>
